export default "__VITE_ASSET__aGaAFs8Y__"